import(/* webpackMode: "eager" */ "/opt/synthhotel/node_modules/next/dist/client/link.js");
